<template>
  <div class="box-container">
    <v-property-status-list :property-id="model.id" :property="model" />
  </div>
</template>

<script>
import list from "./_list.vue";

export default {
  components: {
    "v-property-status-list": list,
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  metaInfo() {
    return {
      title: this.$t("property_statuses").capitalize(),
    };
  },
};
</script>
